var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6878 8.09531V5.49219C30.6878 4.27385 30.2038 3.10541 29.3423 2.24392C28.4808 1.38242 27.3124 0.898438 26.094 0.898438H23.0315C21.8132 0.898438 20.6448 1.38242 19.7833 2.24392C18.9218 3.10541 18.4378 4.27385 18.4378 5.49219V8.09531C14.6297 9.43469 11.3686 11.9908 9.15842 15.3688C9.04782 15.5377 8.97157 15.7267 8.93403 15.9251C8.8965 16.1235 8.8984 16.3273 8.93963 16.5249C9.02291 16.9241 9.26134 17.2738 9.60248 17.4972C9.94361 17.7206 10.3595 17.7992 10.7587 17.716C11.1578 17.6327 11.5076 17.3943 11.7309 17.0531C13.3302 14.5942 15.6021 12.6464 18.2764 11.4413C20.9507 10.2362 23.9148 9.82464 26.8163 10.2555C29.7177 10.6863 32.4344 11.9414 34.6431 13.8716C36.8519 15.8017 38.4598 18.3256 39.2756 21.1432C40.0914 23.9607 40.0808 26.9532 39.245 29.7649C38.4092 32.5766 36.7834 35.089 34.561 37.0035C32.3386 38.9179 29.6132 40.1537 26.7087 40.5639C23.8043 40.9741 20.8431 40.5415 18.1775 39.3175C17.8079 39.149 17.3865 39.1341 17.006 39.2763C16.6256 39.4184 16.3171 39.7059 16.1486 40.0755C15.98 40.445 15.9652 40.8664 16.1074 41.2469C16.2495 41.6274 16.537 41.9358 16.9065 42.1044C19.1666 43.1673 21.6196 43.7583 24.1157 43.8413C26.6118 43.9244 29.0986 43.4977 31.4243 42.5874C33.75 41.677 35.8657 40.3022 37.6422 38.5467C39.4186 36.7913 40.8186 34.6921 41.7566 32.3774C42.6945 30.0627 43.1508 27.5811 43.0975 25.0842C43.0442 22.5873 42.4824 20.1274 41.4465 17.8549C40.4106 15.5824 38.9223 13.5449 37.0725 11.8669C35.2227 10.1889 33.0502 8.90554 30.6878 8.09531ZM21.5003 7.31438V5.49219C21.5003 5.08607 21.6616 4.6966 21.9488 4.40943C22.2359 4.12227 22.6254 3.96094 23.0315 3.96094H26.094C26.5002 3.96094 26.8896 4.12227 27.1768 4.40943C27.464 4.6966 27.6253 5.08607 27.6253 5.49219V7.29906C26.6139 7.12179 25.5895 7.02959 24.5628 7.02344C23.5357 7.03536 22.5113 7.13267 21.5003 7.31438Z",
    fill: "url(#paint0_linear_201_415)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4131 18.3241C33.1605 18.0086 32.7933 17.8058 32.3917 17.7599C31.9901 17.714 31.5867 17.8288 31.2694 18.0791L26.9666 21.5091C26.2498 21.0477 25.415 20.8031 24.5625 20.8048C23.6539 20.8048 22.7658 21.0742 22.0104 21.5789C21.2549 22.0837 20.6661 22.8012 20.3184 23.6406C19.9707 24.48 19.8798 25.4036 20.057 26.2947C20.2343 27.1858 20.6718 28.0043 21.3142 28.6468C21.9567 29.2892 22.7752 29.7267 23.6663 29.904C24.5574 30.0812 25.4811 29.9903 26.3205 29.6426C27.1599 29.2949 27.8773 28.7061 28.3821 27.9507C28.8868 27.1952 29.1563 26.3071 29.1563 25.3985C29.1543 24.8759 29.061 24.3577 28.8806 23.8673L33.1681 20.4373C33.4748 20.1854 33.6718 19.8244 33.7175 19.4302C33.7632 19.036 33.6541 18.6395 33.4131 18.3241Z",
    fill: "url(#paint1_linear_201_415)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8438 20.8047H4.65625C4.25014 20.8047 3.86066 20.966 3.57349 21.2532C3.28633 21.5403 3.125 21.9298 3.125 22.3359C3.125 22.7421 3.28633 23.1315 3.57349 23.4187C3.86066 23.7059 4.25014 23.8672 4.65625 23.8672H13.8438C14.2499 23.8672 14.6393 23.7059 14.9265 23.4187C15.2137 23.1315 15.375 22.7421 15.375 22.3359C15.375 21.9298 15.2137 21.5403 14.9265 21.2532C14.6393 20.966 14.2499 20.8047 13.8438 20.8047Z",
    fill: "url(#paint2_linear_201_415)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8438 26.9297H1.59375C1.18764 26.9297 0.798158 27.091 0.510993 27.3782C0.223828 27.6653 0.0625 28.0548 0.0625 28.4609C0.0625 28.8671 0.223828 29.2565 0.510993 29.5437C0.798158 29.8309 1.18764 29.9922 1.59375 29.9922H13.8438C14.2499 29.9922 14.6393 29.8309 14.9265 29.5437C15.2137 29.2565 15.375 28.8671 15.375 28.4609C15.375 28.0548 15.2137 27.6653 14.9265 27.3782C14.6393 27.091 14.2499 26.9297 13.8438 26.9297Z",
    fill: "url(#paint3_linear_201_415)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8438 33.0547H4.65625C4.25014 33.0547 3.86066 33.216 3.57349 33.5032C3.28633 33.7903 3.125 34.1798 3.125 34.5859C3.125 34.9921 3.28633 35.3815 3.57349 35.6687C3.86066 35.9559 4.25014 36.1172 4.65625 36.1172H13.8438C14.2499 36.1172 14.6393 35.9559 14.9265 35.6687C15.2137 35.3815 15.375 34.9921 15.375 34.5859C15.375 34.1798 15.2137 33.7903 14.9265 33.5032C14.6393 33.216 14.2499 33.0547 13.8438 33.0547Z",
    fill: "url(#paint4_linear_201_415)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_415",
    x1: 8.90723,
    y1: 22.375,
    x2: 43.1017,
    y2: 22.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208,
    stopColor: "#03EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2931,
    stopColor: "#24D2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5538,
    stopColor: "#3CBDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#4AB0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FACFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_415",
    x1: 19.9687,
    y1: 23.8711,
    x2: 33.7277,
    y2: 23.8711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208,
    stopColor: "#03EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2931,
    stopColor: "#24D2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5538,
    stopColor: "#3CBDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#4AB0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FACFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_201_415",
    x1: 3.125,
    y1: 22.3359,
    x2: 15.375,
    y2: 22.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208,
    stopColor: "#03EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2931,
    stopColor: "#24D2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5538,
    stopColor: "#3CBDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#4AB0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FACFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_201_415",
    x1: 0.0625,
    y1: 28.4609,
    x2: 15.375,
    y2: 28.4609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208,
    stopColor: "#03EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2931,
    stopColor: "#24D2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5538,
    stopColor: "#3CBDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#4AB0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FACFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_201_415",
    x1: 3.125,
    y1: 34.5859,
    x2: 15.375,
    y2: 34.5859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208,
    stopColor: "#03EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2931,
    stopColor: "#24D2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5538,
    stopColor: "#3CBDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#4AB0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FACFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b91354bdf1cd7e19015282699032e152.svg";
export { ForwardRef as ReactComponent };